module.exports = __webpack_public_path__ + "img/lead-8e.9c17b064.png";